'use strict';

angular.module('admin.user', [])

.decorator('usersViewOptions', ['$delegate', '$window', function ($delegate, $window)
{
    $delegate.toolbar.push({
        name: 'export',
        buttonClass: 'btn btn-default',
        template: '<i class="glyphicon glyphicon-komondor-export"></i>Export Users List',
        act: function () {
            $window.open('/api/users-export', '_blank');
        },
        show: function () {
            return true;
        }
    });

    $delegate.list.columns.splice(3, 0, {
        label: 'Created',
        name: ('created_at | date'),
        sortable: true
    });
    return $delegate;
}]);

